import React from "react";
import get from "lodash/get";
import { getPublishRouteOmissions, getRouteSuggestions } from "utils/publish";
import { useFormikContext } from "formik";
import { FORM_KEY } from "utils/constants/form";
import classnames from "classnames";
import { STATE_KEYS } from "utils/constants/state";

const RouteSuggestions = () => {
  const {
    values,
    errors,
    setFieldValue,
    setFieldTouched,
    touched
  } = useFormikContext();

  const routeSuggestions = values[FORM_KEY].routeSuggestions;
  const ctxRouteSuggestions = Array.isArray(routeSuggestions)
    ? routeSuggestions
    : null;
  const newRoute = get(values, STATE_KEYS.PUBLISH.NEW_ROUTE);
  const newRouteTouched = get(touched, STATE_KEYS.PUBLISH.NEW_ROUTE);
  const errorType = errors && errors.type;

  const omissions = getPublishRouteOmissions(values[FORM_KEY].existingRoutes);

  const suggestions = getRouteSuggestions({
    suggestions: ctxRouteSuggestions,
    errorType,
    route: newRoute,
    omissions
  });
  if (!suggestions.length) {
    return null;
  }

  const nodes = suggestions.map((suggestion) => {
    const active = newRoute === suggestion;
    return (
      <div
        key={suggestion}
        className={classnames("ma1 pa2 f5 ba pointer br2 bg-white--hover", {
          "hairline-1": !active,
          "b--primary": active
        })}
        onClick={() => {
          setFieldValue(STATE_KEYS.PUBLISH.NEW_ROUTE, suggestion);
          if (!newRouteTouched) {
            setFieldTouched(STATE_KEYS.PUBLISH.NEW_ROUTE, true);
          }
        }}
      >
        {`/${suggestion}`}
      </div>
    );
  });

  return (
    <div className="pt3 mt1">
      <div className="field__label fw5 db">Suggestions</div>
      <div className="br2 ba hairline-1 pa2">
        <div className="flex flex-wrap">{nodes}</div>
      </div>
    </div>
  );
};

export default RouteSuggestions;
